import { Breadcrumbs } from '@innovationnorway/cl-react';
import { breadCrumbs } from '../assets/localizations/localizationsBreadcrumbs';
import { useLocalizer } from '../hooks';
import { useMinSideLink } from '../hooks/useGetMinSideLink';

const AppBreadcrumbs = ({ currentPageName }: { currentPageName: string }) => {
  const { typeSafeL } = useLocalizer('BreadCrumbs');
  const localization = typeSafeL<typeof breadCrumbs>;
  const minSideLink = useMinSideLink();

  return (
    <Breadcrumbs className="mb-6">
      <Breadcrumbs.List>
        <Breadcrumbs.Item>
          <Breadcrumbs.Link rel="noreferrer" href={minSideLink?.url ?? '#'}>
            {localization('mypage')}
          </Breadcrumbs.Link>
        </Breadcrumbs.Item>
        <Breadcrumbs.Item>
          <Breadcrumbs.Link>{currentPageName}</Breadcrumbs.Link>
        </Breadcrumbs.Item>
      </Breadcrumbs.List>
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
